export const comments_3750240 = {"data":{"data":[],"links":{}}}